import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import NumberedStepsIllustration from '../../components/NumberedStepsIllustration';
import SafeBrowsing from '../../components/SafeBrowsing';
import stepIllustration from '../../../../../../assets/civil/frameworks/step-bg.png';
import CardBg1 from '../../../../../../assets/sme/ics/attacker/card_bg_1.png';
import CardBg2 from '../../../../../../assets/sme/ics/attacker/card_bg_2.png';
import CardBg3 from '../../../../../../assets/sme/ics/attacker/card_bg_3.png';
import CardBg4 from '../../../../../../assets/sme/ics/attacker/card_bg_4.png';
import CardBg5 from '../../../../../../assets/sme/ics/attacker/card_bg_5.png';
import Safe1 from '../../../../../../assets/civil/frameworks/safe1.png';
import Safe2 from '../../../../../../assets/civil/frameworks/safe2.png';
import Safe3 from '../../../../../../assets/civil/frameworks/safe3.png';
import Safe4 from '../../../../../../assets/civil/frameworks/safe4.png';
import { useStore } from '../../../../store';
const STEP_CARD_BACKGROUNDS = [CardBg1, CardBg2, CardBg3, CardBg4, CardBg5];

const SECTION2_SLIDE_ICONS: Record<number, string> = {
  1: Safe1,
  2: Safe2,
  3: Safe3,
  4: Safe4,
};

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();

  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[1],
    [settings?.paragraphs]
  );
  // const handleStepsComplete = useCallback(() => {
  //   updateComponentState(p_course, p_topic, ID, 'civil-frameworks-section1-1');
  // }, [updateComponentState, p_course, p_topic]);
  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  const toCardItems = (items: any[]) =>
    (items || []).map((item: any) => ({
      title: item.title || '',
      content: item.content || '',
      active: item.active,
    }));

  return (
    <div className="frameworks-section">
      <div className="content-block content-block-cards">
        <HighlightedCardsGrid
          mainTitle={paragraphSettings?.title}
          subTitle={paragraphSettings?.section1Title}
          description={paragraphSettings?.section1Desc}
          centerTitle={true}
          singleRow={true}
          items={toCardItems(paragraphSettings?.section1Items)}
        />
      </div>
      <div className="content-block content-block-steps">
        <NumberedStepsIllustration
          mainTitle={paragraphSettings?.section3Title}
          description={paragraphSettings?.section3Desc}
          items={(paragraphSettings?.section3Items || []).map(
            (item: any, index: number) => ({
              text: item.text || '',
              backgroundImage:
                STEP_CARD_BACKGROUNDS[index % STEP_CARD_BACKGROUNDS.length],
            })
          )}
          illustration={<img src={stepIllustration} alt="" />}
        />
      </div>
      <div className="content-block content-block-cards">
        <SafeBrowsing
          subTitle={paragraphSettings?.section2Title}
          description={paragraphSettings?.section2Desc}
          slides={(paragraphSettings?.section2Items || []).map(
            (item: any, index: number) => ({
              id: index + 1,
              title: item.title || '',
              description: item.content || '',
              icon: SECTION2_SLIDE_ICONS[index + 1],
            })
          )}
        />
      </div>
    </div>
  );
};

export default Section1;
